import React, { useState, useEffect, useContext } from 'react'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import moment from 'moment-timezone'
import PropTypes from 'prop-types'
/* --------------------------------------------- */
import { routeVarMap } from '../../route'
/* --------------------------------------------- */
import utils from '../../utils/utils'
/* --------------------------------------------- */
import DeleteIconLine from '.././icons/DeleteIconLine'
import { GlobalContext } from '../../context/global.context'
import InfoIcon from '.././icons/InfoIcon'
import {
  BottomLabel, Item, FavDelBtn, ImgHolder, Title, ProgressBar, TopLabel, PlayIconWithTheme,
  HoverContainer
} from './style'
import RailHeader from './RailHeader'
import RailFooter from './RailFooter'
/* --------------------------------------------- */
// RailHeader component for displaying rail items.
const RailItems = ({
  index, tagConfiguration, stage, isRailItemPlayBtn, componentStyles, type, layoutType, images, broadcastStartTime, isTitleInsideImg,
  isOpenInNewTab, isBlank, theme, favouritesPage, tags = [], episodeNumber, isShowRailItemInfo, duration, progress = 0, isPlaceholder,
  title, logo, channelNumber, isThisCREATE, hideHoverIcon, sport, tournament, seasonNumber, contentType, nowProgramDetails, nextProgramDetails, displayTitle, seriesTitle, displayDuration, purchaseMode = ''
}) => {
  let [topLabelText, updateTopLabelText] = useState('')
  const [recentlyWatchedTimeRemaining, updateRecentlyWatchedTimeRemaining] = useState('')
  const {  isAuthenticated } = useContext(GlobalContext)
  /* --------------------------------------------- */
  const params = useParams()
  /* --------------------------------------------- */
  const { appMessages } = useSelector(store => store.appConfigReducers)
  const { playerFeature } = useSelector(store => store.featuresReducers)
  /* --------------------------------------------- */
  const { showItemTitle, showItemTopLabel, showItemBottomLabel, maxItemBottomLabelLines } = componentStyles[0] || {}
  /* --------------------------------------------- */
  const isLive = moment().isAfter(utils.convertUTCtoRelativeTimezone(broadcastStartTime))
  let topLabelText0 = ''
  let topLabelTextLength = 0
  progress = progress || 0
  /* --------------------------------------------- */
  /**
   * It: Trims leading zeros from given time string.
   */
  const trimLeadingZeroesFromTime = (inputTime) => {
    if (inputTime) {
      let arr = inputTime.split(' ')
      arr = arr.map(e => {
        for (let i = 0; i < e.length; i++) {
          if (e[i] !== '0') {
            return (e.slice(i))
          }
        }
        return ('0')
      })
      return (arr.join(' '))
    }
  }
  /* --------------------------------------------- */
  /**
   * It: Updates top label
   */
  useEffect(() => {
    if (isLive) {
      updateTopLabelText(appMessages.media_label_on_now)
    } else if (broadcastStartTime) {
      updateTopLabelText(moment(utils.convertUTCtoRelativeTimezone(broadcastStartTime)).format('MMM DD | h:mm A'))
    }
  }, [appMessages, broadcastStartTime, isLive])
  /* --------------------------------------------- */
  /**
   * It: Updates recently watched time.
   */
  useEffect(() => {
    if (isShowRailItemInfo) {
      let dur = duration
      let prog = progress
      if (utils.isNull(duration)) {
        dur = displayDuration
      }
      if (utils.isNull(progress)) {
        prog = 0
      }
      if (utils.isNotNull(dur) && utils.isNotNull(prog)) {
        const maxResumePercent = playerFeature.maxResumePercent || 95
        if (prog > dur) dur = prog
        const currentPerc = (prog * 100) / dur
        let isFullyWatched = false
        let diff = dur - prog
        if (currentPerc >= maxResumePercent) {
          diff = dur
          isFullyWatched = true
        }
        let recentlyWatchedTimeRemaining = utils.millisToMinutesAndSeconds2(diff, {
          hr: appMessages.label_recently_watched_hr,
          min: appMessages.label_recently_watched_min,
          sec: appMessages.label_recently_watched_sec
        })
        if (!isFullyWatched) {
          if (recentlyWatchedTimeRemaining[0] === '0') recentlyWatchedTimeRemaining = recentlyWatchedTimeRemaining.substring(1)
          updateRecentlyWatchedTimeRemaining(`${recentlyWatchedTimeRemaining} ${appMessages.label_recently_watched_left}`)
        } else {
          updateRecentlyWatchedTimeRemaining('')
        }
      }
    }
  }, [
    progress,
    duration,
    displayDuration,
    isShowRailItemInfo,
    playerFeature.maxResumePercent,
    appMessages.label_recently_watched_hr,
    appMessages.label_recently_watched_min,
    appMessages.label_recently_watched_sec,
    appMessages.label_recently_watched_left
  ])
  /* --------------------------------------------- */
  /**
   * It: Sets title.
   */
  if (type) {
    if (type !== 'sportingevent' && type !== 'sportingEvent') {
      topLabelText0 = sport
      topLabelText = tournament
    }
    if (type !== 'tournament') {
      title = `${stage ? `${stage} : ` : ''}${title}`
    }
    if (type === 'episode') {
      if (params.type === routeVarMap.type.series) title = `${appMessages.label_details_episode} ${episodeNumber} - ${title}`
      else if (displayTitle) title = displayTitle
      else if (seriesTitle) title = `${seriesTitle} : ${appMessages.label_details_season_prefix}${seasonNumber} ${appMessages.label_details_episode_prefix}${episodeNumber}`
      else title = `${seasonNumber ? appMessages.label_details_season_prefix : ''} ${seasonNumber ? seasonNumber : ''} ${title} `

    }
  }

  let bottomLabel = ''

  if (showItemBottomLabel && tags.length) {
    bottomLabel = `tag_${tags[0]}`
  }

  topLabelTextLength = topLabelText0 && topLabelText0.length
  /* --------------------------------------------- */
  const showFreeTagConfig = !isAuthenticated && tagConfiguration?.[0]
  const tagBackgroundColor = showFreeTagConfig?.tagStyle?.background?.primary
  const tagTextColor = showFreeTagConfig?.tagStyle?.text?.primary

  return (
    <>
      <Item theme={theme} {...{ componentStyles, layoutType, contentType, isThisCREATE }} className='layout-item' data-index={index}>
       {purchaseMode.toLowerCase() === 'free' && showFreeTagConfig  &&  <div className='free-tag' style={{ backgroundColor: tagBackgroundColor, color: tagTextColor }}>{showFreeTagConfig.label}</div>}
        {showItemTopLabel && !isPlaceholder &&
          <TopLabel className='layout-item__top-title' {...{ componentStyles, topLabelTextLength, theme, isLive }}>
            {topLabelText0 && <span style={{ fontWeight: 'bold' }}>{topLabelText0.toUpperCase()}</span>}
            {topLabelText && <p className={`${!topLabelText0 ? 'label-only' : ''}`}>{topLabelText}</p>}
          </TopLabel>}
        {favouritesPage &&
          <div className='fav-del-btn'>
            <FavDelBtn className='fav-del-btn___wrapper' {...{ theme }}>
              <DeleteIconLine color={theme?.body?.accent?.secondary} style={{ width: 20, height: 20 }} />
            </FavDelBtn>
          </div>}
        {contentType === 'channels' && isThisCREATE && !isPlaceholder && <RailHeader channelLogo={logo} channelNumber={channelNumber} />}
        <ImgHolder className='img-holder' {...{ contentType, isThisCREATE, componentStyles, theme, layoutType, isTitleInsideImg, images, isShowRailItemInfo }}>
          {images.length > 0 &&
            <div className={`img-holder__img-container ${isShowRailItemInfo && !isPlaceholder ? 'img-holder__img-container---info' : ''}`} />}
          <div target={(isOpenInNewTab) ? '_blank' : ''}>
            {!isBlank &&
              <HoverContainer {...{ theme }} className='img-holder__hover-container'>
                {!hideHoverIcon && <span className='img-holder__helper' />}
                {isRailItemPlayBtn && (!hideHoverIcon && <PlayIconWithTheme {...{ theme }} className='img-holder__icon img-holder__icon--play' />)}
              </HoverContainer>}
          </div>
          {(showItemBottomLabel && !isPlaceholder && tags.length) ? (
            <BottomLabel {...{ maxItemBottomLabelLines, theme }} className='layout-item__premium-tag'>
              <p>{appMessages[bottomLabel]}</p>
            </BottomLabel>
          ) : null}
          {isShowRailItemInfo && !isPlaceholder &&
            <div className='rail-item-info-wrapper'>
              <div className='rail-item-info___head'>
                <div className='rail-item-info_icon'>
                  <InfoIcon color={theme?.body?.accent?.secondary} style={{ width: 24, height: 24 }} />
                </div>
                {recentlyWatchedTimeRemaining && <p className='remaining_time_p'>{trimLeadingZeroesFromTime(recentlyWatchedTimeRemaining.trim())}</p>}
              </div>
              <ProgressBar {...{ duration, progress, theme }} className='rail-item-info___progress' />
            </div>}
        </ImgHolder>
        {contentType === 'channels' && isThisCREATE &&
          <>
            {!isPlaceholder && <RailFooter title={nowProgramDetails && nowProgramDetails.title && nowProgramDetails.title} time={nowProgramDetails && nowProgramDetails.time && nowProgramDetails.time} nextP={false} />}
            {!isPlaceholder && <RailFooter title={nextProgramDetails && nextProgramDetails.title && nextProgramDetails.title} time={nextProgramDetails && nextProgramDetails.time && nextProgramDetails.time} nextP={true} />}
          </>
        }
        {showItemTitle &&
          <Title {...{ contentType, isThisCREATE, componentStyles, theme, isTitleInsideImg }} className={`layout-item__title ${isTitleInsideImg ? 'layout-item__title---inside-img' : ''}`} {...{ title }}>
            {title}
          </Title>}
      </Item>
    </>
  )
}
         

/* --------------------------------------------- */
RailItems.propTypes = {
  /** index of rail item */
  index: PropTypes.number,
  /** title */
  stage: PropTypes.string,
  /** show/hide play button */
  isRailItemPlayBtn: PropTypes.bool,
  /** theme */
  componentStyles: PropTypes.array,
  /** type of rail item (grid/rail) */
  type: PropTypes.string,
  /** rail item images array */
  images: PropTypes.array,
  /** broadcast time */
  broadcastStartTime: PropTypes.number,
  /** whether to open in new tab. */
  isOpenInNewTab: PropTypes.bool,
  /** Is blank rail item. */
  isBlank: PropTypes.bool,
  /** uId of railitem. */
  uid: PropTypes.string,
  /** theme. */
  theme: PropTypes.object,
  /** rail item title */
  title: PropTypes.string,
  /** show/hide hover icon */
  hideHoverIcon: PropTypes.bool,
  /** type */
  layoutType: PropTypes.string,
  /** sport title */
  sport: PropTypes.string,
  /** tournament title */
  tournament: PropTypes.string
}
/* --------------------------------------------- */
RailItems.defaultProps = {
  index: -1,
  stage: '',
  isRailItemPlayBtn: false,
  componentStyles: [],
  layoutType: 'rail',
  images: [],
  broadcastStartTime: 0,
  isOpenInNewTab: false,
  isBlank: false,
  uid: '0',
  theme: {},
  title: '',
  hideHoverIcon: false,
  type: '',
  sport: '',
  tournament: ''
}
/* --------------------------------------------- */
export default RailItems
  /* --------------------------------------------- */
